module.exports = __webpack_public_path__ + "static/media/windows1.d728c1ca.png";